import ReactMarkdown, { Options } from 'react-markdown'
import { sanitizeMarkdown } from './markdown.utils'

export const Markdown = ({ children, ...rest }: Options) => {
    return <ReactMarkdown {...rest}>{sanitizeMarkdown(children)}</ReactMarkdown>
}
